import { useState } from 'react'
import { HeadlineComponent } from './headline.component'
import { IncidentTable } from './incident.table.component'

export const RepairWorkPage: React.FC = () => {
	const [searchStreetId, setSearchStreetId] = useState<number | undefined>(
		undefined,
	)

	return (
		<div style={{ paddingTop: '140px' }}>
			<HeadlineComponent onSearch={setSearchStreetId} />
			<IncidentTable streetId={searchStreetId} />
		</div>
	)
}
